import React from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

function Particle() {
   const particlesInit = async (main) => {
      await loadFull(main);
   };

   return (
      <Particles
         init={particlesInit}
         id="tsparticles"
         options={{
            particles: {
               number: {
                  value: 200,
                  density: {
                     enable: true,
                     value_area: 2400,
                  },
               },
               line_linked: {
                  enable: false,
                  opacity: 0.03,
               },
               move: {
                  direction: 'right',
                  speed: 0.5,
               },
               size: {
                  value: 2,
               },
               opacity: {
                  anim: {
                     enable: true,
                     speed: 1.5,
                     opacity_min: 0.05,
                  },
               },
            },

            retina_detect: true,
         }}
      />
   );
}

export default Particle;
